import React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";

var ForgotPassword = function ForgotPassword() {
  return ___EmotionJSX("div", null, "Forgot Password");
};

export default ForgotPassword;